import baseAPI from '@/api/base';
import { EditProjectFile, GetProjectFile, RegisterProjectFile } from '@/dtos/project_file.dto';
import {
  DELETE_PROJECT_FILE_URL,
  EDIT_PROJECT_FILE_URL,
  GET_PROJECT_FILE_URL,
  REGISTER_PROJECT_FILE_URL,
  TOGGLE_PROJECT_FILE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ProjectFile {
  static getProjectFiles = async (getProjectFile: GetProjectFile): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_FILE_URL, {
      params: getProjectFile,
    });
    console.log('response', response);
    return response;
  };

  static registerProjectFile = async (
    registerProjectFile: RegisterProjectFile | FormData
  ): Promise<AxiosResponse> => {
    const config = registerProjectFile instanceof FormData 
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : {};
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_PROJECT_FILE_URL,
      registerProjectFile instanceof FormData 
        ? registerProjectFile 
        : { ...registerProjectFile },
      config
    );
    console.log('response', response);
    return response;
  };

  static editProjectFile = async (editProjectFile: EditProjectFile | FormData): Promise<AxiosResponse> => {
    const config = editProjectFile instanceof FormData 
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : {};
    const response: AxiosResponse = await baseAPI.put(
      EDIT_PROJECT_FILE_URL,
      editProjectFile instanceof FormData 
        ? editProjectFile 
        : { ...editProjectFile },
      config
    );
    return response;
  };

  static toggleProjectFileIsActive = async (
    editProjectFile: EditProjectFile
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PROJECT_FILE_IS_ACTIVE_URL,
      {
        ...editProjectFile,
      }
    );
    return response;
  };

  static deleteProjectFile = async (projectFileId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PROJECT_FILE_URL}/${projectFileId}`
    );
    return response;
  };
}

export default ProjectFile;

